(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-observer.js') >= 0) return;  svs.modules.push('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-observer.js');
"use strict";


const {
  useRef,
  useEffect,
  useContext
} = React;
const {
  ReactIntersectionContext
} = svs.components.lbUtils.intersectionObserver;
const ReactIntersectionObserver = _ref => {
  let {
    onIntersection,
    children,
    isObserving = true,
    options = {}
  } = _ref;
  const {
    observeElement,
    unobserveElement,
    disconnectElement,
    connectElement,
    changeElementCallback
  } = useContext(ReactIntersectionContext);
  const intersectionEl = useRef();
  useEffect(() => {
    const _intersectionEl = intersectionEl.current;
    connectElement(_intersectionEl, null, options);
    return () => {
      disconnectElement(_intersectionEl);
    };
  }, [connectElement, disconnectElement, options]);
  useEffect(() => {
    const _intersectionEl = intersectionEl.current;
    changeElementCallback(_intersectionEl, onIntersection);
  }, [onIntersection, changeElementCallback]);
  useEffect(() => {
    const _intersectionEl = intersectionEl.current;
    const _isObserving = isObserving;
    if (_isObserving) {
      observeElement(_intersectionEl);
    }
    return () => {
      if (_isObserving) {
        unobserveElement(_intersectionEl);
      }
    };
  }, [isObserving, observeElement, unobserveElement]);
  return React.createElement("div", {
    ref: intersectionEl
  }, children);
};
setGlobal('svs.components.lbUtils.intersectionObserver.ReactIntersectionObserver', ReactIntersectionObserver);

 })(window);